import { faCodeCompare } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ButtonProps } from "react-bootstrap";
import { StdButton } from "./StdButton";

import styles from "./Button.module.scss";

interface CompareButtonProps extends ButtonProps {}

export const CompareButton: React.FC<CompareButtonProps> = props => {
    return (
        <StdButton {...props} variant="std">
            <FontAwesomeIcon icon={faCodeCompare} className={`mr-2 ${styles.icon}`} />
            {props.children ?? "Compare with another provider"}
        </StdButton>
    );
};
